/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Button, Collapse, Drawer, Form, Skeleton } from "antd";
import UserTaskForm from "./user-task-form";
import { FaChevronRight } from "react-icons/fa";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@apollo/client";
import { UPDATE_USER_TASK, ARCHIVE_USER_TASK, UPDATE_USER_TASK_AS_COMPLETE, UPDATE_USER_TASK_AS_WONT_COMPLETE } from "../../graphql/mutation";
import { GET_USER_TASK } from "../../graphql/queries";
import { ExpandDrawer } from "../../icons";
import TaskCustomForm from "./task-custom-form";
import TaskFooter from "./task-footer";
import "./index.css";

const canManagePolicy = {
  USER_TASK: true
};

const UserTaskViewDrawer = (props) => {
  const [drawerExpanded, setDrawerExpanded] = useState(false);
  const [documentDrawerExpanded, setDocumentDrawerExpanded] = useState(false);
  //const { canManagePolicy, currentOrganization } = useAuth();
  const {
    userTaskId,
    showTaskDrawer,
    onClose,
    itsTimeToSave,
    resetTheTimer,
    organizationId,
    isMobile,
    afterUpdate,
    isActive,
    widgetSettings,
  } = props;


  const {
    loading: userTaskLoading,
    data: userTaskData,
    refetch: userTaskRefetch,
  } = useQuery(GET_USER_TASK, {
    variables: { id: userTaskId },//"clxxj0q8l000001s64dk1shz2"
    skip: !userTaskId,
    fetchPolicy: "no-cache",
  });

  const [updateUserTask] = useMutation(UPDATE_USER_TASK);
  const [completeUserTask, { data: CompleteUserTask }] = useMutation(UPDATE_USER_TASK_AS_COMPLETE);
  const [wontCompleteUserTask, { data: WontCompleteUserTask }] = useMutation(UPDATE_USER_TASK_AS_WONT_COMPLETE);
  const [archiveUserTask, { data: ArchiveUserTask }] = useMutation(ARCHIVE_USER_TASK);

  const [showAuthTasks, setShowAuthTasks] = useState(false);
  const [hasForms, setHasForms] = useState(false);
  const [customFormFieldsDisabled, setCustomFormFieldsDisabled] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState("");

  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [viewDocument, setViewDocument] = useState({});
  const [urlToView, setUrlToView] = useState("");
  const [page, setPage] = useState<number>(1);

  // Footer Button Visibility
  const [showArchiveBtn, setShowArchiveBtn] = useState(false);
  const [showCompleteBtn, setShowCompleteBtn] = useState(canManagePolicy["USER_TASK"]);
  const [showWontCompleteBtn, setShowWontCompleteBtn] = useState(false);
  const [showUpdateBtn, setShowUpdateBtn] = useState(canManagePolicy["USER_TASK"]);

  const [userTask, setUserTask] = useState(null);

  const customFormRef = useRef({ onSubmit: null });

  const [form] = Form.useForm();
  const drawerContainerRef = useRef();
  const drawerContainerRef2 = useRef();

  useEffect(() => {
    if (!userTaskLoading && userTaskData) {
      setUserTask(userTaskData.getUserTask);
      setShowAuthTasks(userTaskData.getUserTask?.tags?.includes("New Enrollment")); //&& !!referralUserTaskServiceInstance;
      setHasForms(userTaskData.getUserTask.customFormServiceInstanceId || userTaskData.getUserTask.customFormInstanceWithData);
      setCustomFormFieldsDisabled(userTaskData.getUserTask.status === "CANCELLED" ||
        userTaskData.getUserTask.status === "COMPLETE" ||
        userTaskData.getUserTask.status === "COMPLETED" ||
        userTaskData.getUserTask.status === "WONT_COMPLETE");

      if (canManagePolicy["USER_TASK"] && userTaskData.getUserTask && !userTaskData.getUserTask.archived) {
        setShowArchiveBtn(true)
      }
      /*if (canManagePolicy["USER_TASK"] &&
        props?.userTaskPageSettings?.["wont-complete-button-visible"] !==
        false) {
        setShowWontCompleteBtn(true)
      }*/
    }
    return () => { };
  }, [userTaskLoading, userTaskData]);

  //todo - define task type
  const getTaskHeader = (item: any) => {
    if (userTaskLoading)
      return (
        <Skeleton
          //size="small"
          title={{ width: "35%" }}
          paragraph={{ rows: 1 }}
          active
        />
      );

    if (item) {
      return (
        <p
          style={{
            fontFamily: "'Lato-Bold', 'Lato Bold', 'Lato'",
            fontWeight: 700,
            fontSize: 20,
            marginBottom: 0,
            padding: "10px 100px 10px 0",
          }}
        >
          {item.title}
        </p>
      );
    }
  };

  //Update User Task  Graphql Call
  const updateUserTaskFn = async (newValues: any = {}) => {
    const newFormValues = form.getFieldsValue();
    const existingUserIds = new Set(
      userTask.assignedUsers?.map((user) => user.id),
    );
    const newUserIds = new Set(
      newFormValues?.assignedUsers?.map((item) => item.key),
    );
    const assignedUsersToAdd = [...newUserIds].filter(
      (x) => !existingUserIds.has(x),
    );
    const assignedUsersToRemove = [...existingUserIds].filter(
      (x) => !newUserIds.has(x),
    );

    /*const userTaskInput = {
      id: userTask.id,
      organizationId: userTask.organizationId,
      notes: newValues.notes,
      status: newValues.status,
      wontCompleteReason: newValues.wontCompleteReason,
      archived: newValues.archived,
      dueDateTime: newValues.dueDateTime && newValues.dueDateTime.format(),
      assignedUsersToAdd: assignedUsersToAdd,
      assignedUsersToRemove: assignedUsersToRemove,
      userTags: newFormValues.userTags,
      referToHomeHealthCare: newValues.referToHomeHealthCare,
      referToPersonalCare: newValues.referToPersonalCare,
    };*/
    const newUpdateInput = {
      assignedUsersToAdd: assignedUsersToAdd,
      assignedUsersToRemove: assignedUsersToRemove,
      assignedUserGroupsToAdd: [],
      assignedUserGroupsToRemove: []
    }
    await updateUserTask({
      variables: { id: userTask.id, input: newUpdateInput },
    });
  };
  //Update User Task
  const updateForm = async () => {
    await updateUserTaskFn();
    setIsSubmitting("");
    userTaskRefetch();
    resetTheTimer();
  };
  const updateFormWithCustomForm = async () => {
    setIsSubmitting("update");
    if (userTask && userTask.customFormServiceInstanceId) {
      const eventResponse = await window.formsEventBus.dispatch(
        `user-task-view-drawer-${userTask.customFormServiceInstanceId}_onFormUpdate`,
      );

      // If form has an error, reset UPDATE button
      if (eventResponse === undefined || eventResponse?.error === true) {
        setTimeout(() => {
          setIsSubmitting("");
        }, 500);
      }
    }
  };

  //Complete User Task
  const completeForm = async () => {
    try {
      await completeUserTask({
        variables: { id: userTask.id },
      });
      //await updateUserTaskFn({ status: "COMPLETE" });
      setIsSubmitting("");
      if (afterUpdate) { afterUpdate(true); }
      userTaskRefetch();
      resetTheTimer();
    } catch (e) {
      setIsSubmitting("");
    }
  };
  const completeFormWithCustomForm = async () => {

    try {
      setIsSubmitting("complete");
      if (userTask && userTask.customFormServiceInstanceId) {
        await window.formsEventBus.dispatch(
          `user-task-view-drawer-${userTask.customFormServiceInstanceId}_onFormSubmit`,
        );
      }
    } catch (e) { }

    setTimeout(() => {
      setIsSubmitting("");
    }, 500);
  };

  //Handle Complete User Task from Footer Button
  const handleCompleteForm = () => {
    setIsSubmitting("complete");
    if (userTask.customFormServiceInstanceId) {
      //const customForm = customFormRef && customFormRef.current;
      completeFormWithCustomForm();
    } else {
      completeForm();
    }
  };

  //Handle Update User Task from Footer Button
  const handleUpdateForm = () => {
    setIsSubmitting("update");
    if (userTask.customFormServiceInstanceId) {
      //const customForm = customFormRef && customFormRef.current;
      updateFormWithCustomForm();
    } else {
      updateForm();
    }
  };

  //Handle Won't Complete User Task from Footer Button
  const wontCompleteForm = async (wontCompleteReason: string) => {
    setIsSubmitting("wontcomplete");
    await wontCompleteUserTask({
      variables: { id: userTask.id, wontCompleteReason: wontCompleteReason },
    });
    /*await updateUserTaskFn({
      status: "WONT_COMPLETE",
      wontCompleteReason: wontCompleteReason,
    });*/
    setIsSubmitting("");
    if (afterUpdate) { afterUpdate(true); }
    userTaskRefetch();
    resetTheTimer();
    //wontCompleteReason = "";
  };

  //Handle Archieve User Task from Footer Button
  const archiveTask = async () => {
    setIsSubmitting("archive");
    await archiveUserTask({
      variables: { id: userTask.id },
    });
    //await updateUserTaskFn({ archived: true });
    setIsSubmitting("");
    if (afterUpdate) { afterUpdate(true); }
    userTaskRefetch();
    resetTheTimer();
  };

  const handleUpdatedFormData = () => {
    completeForm();
  };

  const handleOnFormErrors = () => {
    setIsSubmitting("");
  };

  const handleDocuments = (pageNum: number) => {
    setPage(pageNum);
    const initialDocument = userTask?.attachments?.[pageNum - 1 || 0];
    const s3url = new URL(initialDocument?.url);
    let key = "";
    if (initialDocument.url.includes(`s3://${widgetSettings?.bucket}`)) {
      key = initialDocument.url;
    } else {
      key = `s3://${widgetSettings?.bucket}${s3url.pathname}`;
    }
    setViewDocument({
      key: key,
      documentId: initialDocument.id,
      contentType: initialDocument.contentType,
      name: initialDocument?.documentName,
    });
  };

  const handleDocumentsView = () => {
    setShowDocumentViewer(true);
    handleDocuments(1); // set default page to 1
  };

  useEffect(() => {
    return () => form.resetFields();
  }, [form, userTaskId]);

  return (
    <div className="usertask-drawer-form">
      <div ref={drawerContainerRef} />
      <Drawer
        getContainer={drawerContainerRef.current}
        mask={showDocumentViewer ? true : false}
        push={showDocumentViewer ? true : false}
        visible={showTaskDrawer}
        onClose={() => {
          form.resetFields();
          onClose?.();
        }}
        maskClosable={false}
        zIndex={showDocumentViewer && drawerExpanded ? 9999 : 1000}
        title={userTask ? getTaskHeader(userTask) : 'Task Details'}
        width={
          isMobile
            ? window.screen.width
            : drawerExpanded
              ? Math.max(window.innerWidth - 200, 757)
              : showDocumentViewer
                ? "50%"
                : 757
        }
        bodyStyle={{ padding: 0 }}
        headerStyle={{
          color: "rgba(0,0,0,.65)",
          background: "#fff",
          paddingTop: "16px",
          paddingBottom: "24px",
          paddingLeft: "75px",
          borderBottom: "1px solid #e8e8e8",
          borderRadius: "4px 4px 0 0",
          textAlign: "center",
        }}
        destroyOnClose
      >
        <div>
          <Button
            onClick={() => setDrawerExpanded(!drawerExpanded)}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 10,
              display: "block",
              width: "56px",
              height: "56px",
              padding: 0,
              border: 0,
              outline: 0,
              cursor: "pointer",
            }}
          >
            {drawerExpanded ? (
              <FaChevronRight style={{ fill: "#71afb4", width: "2em" }} />
            ) : (
              <ExpandDrawer />
            )}
          </Button>
        </div>
        <div className="usertask-drawer-form">
          {userTask &&
            <UserTaskForm
              {...props}

              userTaskData={userTask}
              userTaskLoading={userTaskLoading}
              handleDocumentViewer={handleDocumentsView}
              form={form}
            />}
          <Collapse
            defaultActiveKey={["auth", "tasks"]}
            expandIconPosition="end"
            expandIcon={(props) =>
              isActive ? <UpOutlined /> : <DownOutlined />
            }
          >
            <Collapse.Panel
              header="Tasks"
              key="tasks"
              className="last-collapse"
            >
              {showAuthTasks && <div>Task Table</div>}
              {(userTask?.tags || []).includes("Review Assessment") && (
                <Button
                  style={{
                    marginBottom: isMobile ? 0 : 15,
                    marginRight: isMobile ? 0 : 30,
                    borderColor: "rgba(45, 78, 119, 1)",
                    color: "rgba(45, 78, 119, 1)",
                    padding: isMobile ? "0 5px" : "0 15px",
                  }}
                  href={`patients/assessments?id=${userTask && userTask.customFormServiceInstanceId
                    }`}
                  target="_blank"
                >
                  Print
                </Button>
              )}

              {userTask && !hasForms && (
                <div>
                  <p>No available forms to fill.</p>
                </div>
              )}
              {userTask && hasForms && (
                <TaskCustomForm
                  userTask={userTask}
                  customFormRef={customFormRef}
                  upadatedFormDataAvailable={handleUpdatedFormData}
                  onFormErrors={handleOnFormErrors}
                  afterCompleteForm={completeForm}
                  afterUpdateForm={updateForm}
                  organizationId={organizationId}
                  //appSyncConfig={appSyncConfig}
                  widgetSettings={widgetSettings}
                />
              )}
            </Collapse.Panel>
          </Collapse>
          <TaskFooter
            userTask={userTask}
            customFormFieldsDisabled={customFormFieldsDisabled}
            customFormRef={customFormRef}
            userTaskLoading={userTaskLoading}
            isSubmitting={isSubmitting}
            archiveTask={archiveTask}
            wontCompleteForm={wontCompleteForm}
            completeForm={handleCompleteForm}
            updateForm={handleUpdateForm}
            isMobile={isMobile}
            itsTimeToSave={itsTimeToSave}
            showDocumentViewer={showDocumentViewer}
            drawerOpen={showTaskDrawer}
            drawerExpanded={drawerExpanded}
            showArchive={showArchiveBtn}
            showUpdate={showUpdateBtn}
            showWontcomplete={showWontCompleteBtn}
            showComplete={showCompleteBtn}
          />
        </div>
      </Drawer>
      <div ref={drawerContainerRef2} />
    </div>
  );
};

export default UserTaskViewDrawer;
